import evaluationApiClient from "common/Adapters/EvaluationApiClient/evaluationApiClient";

export function fetchKeyFigures(lang, data, onError, companyAccess = false) {
  return evaluationApiClient.getKeyFigures(lang, data, onError, companyAccess);
}

export function fetchCompanyDetail(onError, companyAccess) {
  return evaluationApiClient.getCompanyDetail(onError, companyAccess);
}

export function fetchNogaDetail(lang, nogaId, onError) {
  return evaluationApiClient.getNogaDetail(lang, nogaId, onError);
}

export function fetchAllOfficeSizes(lang, onError) {
  return evaluationApiClient.getAllOfficeSizes(lang, onError);
}

export function fetchAllNoga(lang, onError) {
  return evaluationApiClient.getAllNogas(lang, onError);
}
